export default __webpack_public_path__ + "static/media/preview-icon.c28c862e.svg";